<template>
  <div>
    <div class="p-grid">
      <div class="p-col-12 p-md-col-6">
        <div class="text-title">
          Récapitulatif de votre demande
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <p class="text-validate-green">
              {{
                appointmentStore.appointment.glazing
                  ? "Mon intervention"
                  : "Ma prestation"
              }}
            </p>
            <p class="text-validate-black">
              {{ getInterventionName }}
            </p>
            <p
              v-if="appointmentStore.appointment.windshield_reparation !== null"
              class="text-validate-black"
            >
              {{
                appointmentStore.appointment.windshield_reparation === "replace"
                  ? "Remplacement du pare-brise"
                  : "Reparation du pare-brise"
              }}
            </p>
            <p
              v-if="appointmentStore.appointment.intervention_side !== null"
              class="text-validate-black"
            >
              {{
                appointmentStore.appointment.intervention_side === "left"
                  ? "Gauche"
                  : "Droite"
              }}
            </p>
          </div>

          <div class="p-col-12 p-md-6">
            <p class="text-validate-green">Mon véhicule</p>
            <p class="text-validate-black">
              {{ appointmentStore.other_information.brand_name }}
            </p>
            <p class="text-validate-black">
              {{ appointmentStore.appointment.car_model_name }}
            </p>
          </div>

          <div class="p-col-12 p-md-6">
            <p class="text-validate-green">Mes informations</p>
            <p class="text-validate-black">
              Prénom : {{ appointmentStore.appointment.firstname }}
            </p>
            <p class="text-validate-black">
              Nom : {{ appointmentStore.appointment.lastname }}
            </p>
            <p class="text-validate-black">
              Téléphone : {{ appointmentStore.appointment.phone }}
            </p>
            <p class="text-validate-black">
              Email : {{ appointmentStore.appointment.email }}
            </p>
          </div>

          <div class="p-col-12 p-md-6">
            <p class="text-validate-green">Mon rendez-vous</p>
            <p class="text-validate-black">
              Centre :
              {{ appointmentStore.other_information.point_of_sale_name }}
            </p>
            <p class="text-validate-black" v-if="AppointmentDate">Date : {{ AppointmentDate }}</p>
            <p class="text-validate-black" v-if="appointmentStore.appointment.appointment_time">
              Créneau :
              {{
                appointmentStore.appointment.appointment_time === "afternoon"
                  ? "Apres-midi"
                  : appointmentStore.appointment.appointment_time === "morning"
                  ? "Matin"
                  : ""
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button
            class="button-navigate button-back "
            @click="onPrevious"
            label="Je modifie"
        ></Button
        >
      </div>
      <div class="p-mt-sm-3">
        <Button
            v-if="checkQuoteOrAppointment"
            class="button-navigate"
            @click="onAppointmentConfirm"
            label="Je confirme"
            :loading="loading"
        ></Button>
        <Button
            v-else
            class="button-navigate"
            @click="onQuoteConfirm"
            label="Je confirme"
            :loading="loading"
        >
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { moment } from "../utils";

export default {
  name: "StepCheckInformation",
  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const loading = ref(false)

    const onPrevious = () => {
      emit("prevPage", menuStore.currentMenuItem);
    };

    const checkQuoteOrAppointment = computed(() => {
      if (appointmentStore.appointment.request_type !== "quote") {
        return true;
      } else {
        return false;
      }
    });

    const onAppointmentConfirm = async () => {
      try {
        loading.value = true
        const leadId = await appointmentStore.confirmAppointment();
        const nextUrl = "/rendez-vous-confirme";
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/verifier-mes-informations',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        dataLayerToPush.leadId = leadId;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false
      }
    };

    const onQuoteConfirm = async () => {
      try {
        loading.value = true
        const leadId = await appointmentStore.confirmAppointment();
        const nextUrl = "/devis-confirme";
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/verifier-mes-informations',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        dataLayerToPush.leadId = leadId;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false
      }
    };

    const AppointmentDate = computed(() => {
      return appointmentStore.appointment.appointment_date ? moment(appointmentStore.appointment.appointment_date).format(
        "DD-MM-YYYY"
      ) : null;
    });

    const getInterventionName = computed(() => {
      let res = "";
      if (appointmentStore.appointment.glazing !== null)
        switch (appointmentStore.appointment.glazing) {
          case "windshield":
            res = "Pare-brise";
            break;
          case "rear_windshield":
            res = "Lunette arrière";
            break;
          case "side_window":
            res = "Vitres latérales";
            break;
          default:
            break;
        }
      else {
        switch (appointmentStore.appointment.other_service) {
          case "anti-fog":
            res = "Anti-brouillard";
            break;
          case "descaling":
            res =
              appointmentStore.appointment.descaling_option === "prevention"
                ? "Décalaminage : Formule préventive"
                : "Décalaminage : Formule curative";
            break;
          case "mirror_glass":
            res = "Glace-retroviseur";
            break;
          case "optics_headlights_lights":
            res = "Optiques / phares / feux";
            break;
          case "sunroof":
            res = "Toit panoramique";
            break;
          case "anti-rain_treatment":
            res = "Traitement anti-pluie";
            break;

          default:
            break;
        }
      }
      return res;
    });

    return {
      onPrevious,
      onAppointmentConfirm,
      onQuoteConfirm,
      checkQuoteOrAppointment,
      appointmentStore,
      getInterventionName,
      AppointmentDate,
      loading
    };
  },
};
</script>

<style scoped>
@media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
  ::v-deep(.p-button) {
    white-space: nowrap;
  }
}

</style>

<style>
.text-validate-green {
  color: #24a285 !important;
  font-size: 1.5em !important;
  text-align: center !important;
  padding: 25px 15px 5px 15px !important;
}
.text-validate-black {
  color: black !important;
  font-size: 1rem !important;
  line-height: 1.25rem;
  text-align: center !important;
  padding-bottom: 5px !important;
}
</style>
